module.exports = __webpack_public_path__ + "img/left-arrow.b22a94ec.png";